// Which payment gateway the top-up flow uses, and how Toman prices map onto
// each gateway's wire unit.
//
// The whole UI prices in Toman («تومان»). Gateways disagree on the unit they
// settle in — Sepehr (بانک صادرات/شاپرک) takes RIALS, Zarinpal takes Toman — so
// the conversion happens once, here, at the moment we hand an amount to the BFF.

// The gateway table is DATA — `rialsPerToman` decides what a payment is worth,
// and `toGatewayAmount` must not need a translator to compute it. Only the
// bank's display name is copy, so only that is a key.
export const GATEWAYS = {
  sepehr:   { labelKey: 'credits.gateway.saderat',  unit: 'IRR', rialsPerToman: 10 },
  zarinpal: { labelKey: 'credits.gateway.zarinpal', unit: 'IRT', rialsPerToman: 1  },
};

/** Active gateway for new top-ups. */
export const PAYMENT_GATEWAY = 'sepehr';

/** The gateway's name, for the pay button. */
export const gatewayLabel = (t, gateway = PAYMENT_GATEWAY) => {
  const key = GATEWAYS[gateway]?.labelKey;
  return key ? t(key) : '';
};

/** Convert a Toman price into the amount the given gateway expects. */
export function toGatewayAmount(amountToman, gateway = PAYMENT_GATEWAY) {
  const factor = GATEWAYS[gateway]?.rialsPerToman ?? 1;
  return Math.round(amountToman * factor);
}

/**
 * Whether this panel has a rail for credit priced in `currency` (the wallet's
 * `creditPrice.currency`, docs/platform-money/CONTRACT.md). Every gateway above
 * is Iranian and is handed a TOMAN price, so only toman has one: `IRT`, or no
 * currency at all (an older BFF). A dollar price has none until a gateway for it
 * joins the table — no rail, no checkout (CONTRACT rule 5), whatever else says yes.
 */
export function hasRailFor(currency) {
  return !currency || currency === 'IRT';
}
